var map = {
	"./music-instructions.json": 4650,
	"./music-library-intro2024.json": 4651,
	"./music-library-launch2024.json": 4652,
	"./music-progression.json": 4653,
	"./startSourcesAdvanced.json": 4654,
	"./startSourcesSimple.json": 4655,
	"./startSourcesSimple2.json": 4656,
	"./startSourcesTracks.json": 4657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4428;